import { IconSvgProps } from "../types";

export const ZoomOut = ({ size }: IconSvgProps) => (
    <svg
        id="icon-content-zoom out"
        width={size}
        height={size}
        viewBox="0 0 62 63"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fill="currentColor">
                <path
                    d="M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.33,45.33 L44.28,38.38 L59.66,53.76 Z"
                    opacity="0.5"
                />
                <path d="M52.46,26.42 C52.46,11.93 40.72,0.18 26.23,0.18 C11.74,0.18 0,11.93 0,26.42 C0,40.9 11.74,52.65 26.23,52.65 C40.72,52.65 52.46,40.9 52.46,26.42 Z M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z" />
                <path
                    d="M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M38.74,26.72 C38.74,25.2 37.51,23.97 35.99,23.97 L17.08,23.97 L16.95,23.98 C15.5,24.05 14.34,25.25 14.34,26.72 C14.34,28.24 15.56,29.47 17.08,29.47 L35.99,29.47 L36.12,29.46 C37.58,29.39 38.74,28.19 38.74,26.72 Z"
                    opacity="0.5"
                />
            </g>
        </g>
    </svg>
);
